import React, {Component} from 'react';
import imgLogo from '../img/logo-hcpa-troca-senha.png';

class Logo extends Component { 
  render() {
    return (
      <h5 className="card-title text-center">
        <a href={process.env.REACT_APP_URL_INSTITUICAO} target="_new" border="0">
          <img id="logo" className="img-responsive logo-senha" src={imgLogo}  alt={process.env.REACT_APP_TITLE_INSTITUICAO} title={process.env.REACT_APP_TITLE_INSTITUICAO} />
        </a>
      </h5>
    );
  }
}

export default Logo